import { StyleSheet } from 'aphrodite';
import { inputBorderColor } from '../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	dropdownContentInnerOverrides: {
		borderColor: inputBorderColor,
		borderBottomLeftRadius: 8,
		borderBottomRightRadius: 8,
		borderTopRightRadius: 0,
		maxHeight: '550px !important',
	},
	firstDonationCheckbox: {
		marginTop: 8,
		marginBottom: 4,
	},
});
